// extracted by mini-css-extract-plugin
export var active = "menu-module--active--a8314";
export var feature = "menu-module--feature--56f49";
export var feature2 = "menu-module--feature2--fda0b";
export var featureHolder = "menu-module--featureHolder--c5a91";
export var home = "menu-module--home--28787";
export var item = "menu-module--item--3bd81";